import { useCallback } from 'react';
import { useLocale } from '../../LocaleProvider';
import type { UseGetFallbackImage } from './useGetFallbackImage.types';

export const useGetFallbackImage = (): UseGetFallbackImage => {
  const locale = useLocale();

  return useCallback(
    (image: string) => {
      const FALLBACK_REGEXP = new RegExp(`_${locale}`, 'g');
      return image ? image.replace(FALLBACK_REGEXP, '_en') : '';
    },
    [locale],
  );
};
